import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import { Switch } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { get } from 'lodash';

import { ControlBox } from '../../atoms/control-box';
import { ParentPaper } from '../../atoms/parent-paper';
import { SwitchBox } from '../../molecules/switch-box';
import { Group } from '../../organisms/group';
import { useSelector } from '../../store/utils';
import { SliderBox } from '../../molecules/slider-box';

export const SettingsNotifications = () => {
  const { state } = useLocation();

  useEffect(() => {
    if (get(state, 'scroll') === 'app-messages-settings') {
      const element = document.getElementById('notifications');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  }, [state]);

  return (
    <>
      <Group
        title={
          <FormattedMessage
            id="settings.notification"
            defaultMessage="Notifikace"
          />
        }
        layout="list"
        visibility={{ variableId: 'PREMIUM' }}
        id="notifications"
        collapsible
        plus
      >
        <ParentPaper>
          <WebNotifications />
        </ParentPaper>

        <ParentPaper>
          <SwitchBox
            title={
              <FormattedMessage
                id="settings.notification.iverter_disconnected"
                defaultMessage="Výpadek komunikace střídače"
              />
            }
            subtitle={
              <FormattedMessage
                id="settings.notification.iverter_disconnected.subtitle"
                defaultMessage="Notifikace se vygeneruje při začátku a konci výpadku komunikace se střídačem"
              />
            }
            switchVariableId="NOTIF_INVERTER_DISCONNECTED_ENABLE"
            fullWidth
          />
          <SwitchBox
            title={
              <FormattedMessage
                id="settings.notification.utility_loss"
                defaultMessage="Výpadek distribuční sítě"
              />
            }
            subtitle={
              <FormattedMessage
                id="settings.notification.utility_loss.subtitle"
                defaultMessage="Notifikace se vygeneruje při začátku a konci výpadku distribuční sítě"
              />
            }
            switchVariableId="NOTIF_UTILITY_LOSS_ENABLE"
            fullWidth
          />
          <SwitchBox
            title={
              <FormattedMessage
                id="settings.notification.pv_production_mwh"
                defaultMessage="Milník ve výrobě FV energie"
              />
            }
            subtitle={
              <FormattedMessage
                id="settings.notification.pv_production_mwh.subtitle"
                defaultMessage="Notifikace se vygeneruje pokud FVE vygeneruje MWh energie v daném roce"
              />
            }
            switchVariableId="NOTIF_PV_PRODUCTION_MWH_ENABLE"
            fullWidth
          />
        </ParentPaper>
        <ParentPaper>
          <SwitchBox
            title={
              <FormattedMessage
                id="settings.notification.battery_max_soc"
                defaultMessage="Maximální SOC baterie"
              />
            }
            subtitle={
              <FormattedMessage
                id="settings.notification.battery_max_soc.subtitle"
                defaultMessage="Notifikace se vygeneruje při dosažení nastaveného maximálního SOC baterie. Notifikace se vygeneruje pouze 1x denně."
              />
            }
            switchVariableId="NOTIF_BATTERY_MAX_SOC_ENABLE"
            fullWidth
            visibility={{ variableIds: ['PV_BATTERY'] }}
          />
          <SliderBox
            title={
              <FormattedMessage
                id="settings.notification.battery_max_soc_value"
                defaultMessage="Maximální SOC baterie pro notifikace"
              />
            }
            subtitle={
              <FormattedMessage
                id="settings.notification.battery_max_soc_value.subtitle"
                defaultMessage="Nastavte SOC baterie, při jehož dosažení se vygeneruje notifikace."
              />
            }
            variableId="NOTIF_BATTERY_MAX_SOC_VALUE"
            visibility={{ variableIds: ['NOTIF_BATTERY_MAX_SOC_ENABLE'] }}
            max={100}
            opts={{ style: 'percent', maximumFractionDigits: 0 }}
          />
          <SwitchBox
            title={
              <FormattedMessage
                id="settings.notification.battery_min_soc"
                defaultMessage="Minimální SOC baterie"
              />
            }
            subtitle={
              <FormattedMessage
                id="settings.notification.battery_min_soc.subtitle"
                defaultMessage="Notifikace se vygeneruje při poklesu SOC baterie na nastavenou minimální hodnotu. Notifikace se vygeneruje pouze 1x denně."
              />
            }
            switchVariableId="NOTIF_BATTERY_MIN_SOC_ENABLE"
            fullWidth
            visibility={{ variableIds: ['PV_BATTERY'] }}
          />
          <SliderBox
            title={
              <FormattedMessage
                id="settings.notification.battery_min_soc_value"
                defaultMessage="Minimální SOC baterie pro notifikace"
              />
            }
            subtitle={
              <FormattedMessage
                id="settings.notification.battery_min_soc_value.subtitle"
                defaultMessage="Nastavte SOC baterie. Při poklesu na tuto hodnotu se vygeneruje notifikace."
              />
            }
            variableId="NOTIF_BATTERY_MIN_SOC_VALUE"
            visibility={{ variableIds: ['NOTIF_BATTERY_MIN_SOC_ENABLE'] }}
            max={100}
            opts={{ style: 'percent', maximumFractionDigits: 0 }}
          />
        </ParentPaper>
        <ParentPaper>
          <SwitchBox
            title={
              <FormattedMessage
                id="settings.notification.spot_daily_prediction"
                defaultMessage="Denní předpověď"
              />
            }
            subtitle={
              <FormattedMessage
                id="settings.notification.daily_prediction.subtitle"
                defaultMessage="Notifikace se vygeneruje každý den v 8:00"
              />
            }
            switchVariableId="NOTIF_SPOT_DAILY_PREDICTION_ENABLE"
            fullWidth
          />
          <SwitchBox
            title={
              <FormattedMessage
                id="settings.notification.spot_daily_summary"
                defaultMessage="Denní souhrn plánu spotu"
              />
            }
            subtitle={
              <FormattedMessage
                id="settings.notification.spot_daily_summary.subtitle"
                defaultMessage="Notifikace se vygeneruje každý den v 8:00"
              />
            }
            switchVariableId="NOTIF_SPOT_DAILY_SUMMARY_ENABLE"
            fullWidth
            visibility={{ variableIds: ['SP_ON', 'SP_INSTALL'] }}
          />
          <SwitchBox
            title={
              <FormattedMessage
                id="settings.notification.negative_spot"
                defaultMessage="Záporná cena na spotu"
              />
            }
            subtitle={
              <FormattedMessage
                id="settings.notification.negative_spot.subtitle"
                defaultMessage="Notifikace se vygeneruje při začátku a konci záporné ceny na spotu"
              />
            }
            switchVariableId="NOTIF_SPOT_NEGATIVE_ENABLE"
            fullWidth
            visibility={{ variableIds: ['SP_ON', 'SP_INSTALL'] }}
          />
          <SwitchBox
            title={
              <FormattedMessage
                id="settings.notification.spot_charging_battery"
                defaultMessage="Start a konec nabíjení baterie dle spotové ceny"
              />
            }
            subtitle={
              <FormattedMessage
                id="settings.notification.spot_charging_battery.subtitle"
                defaultMessage="Notifikace se vygeneruje při začátku a konci nabíjení baterie dle spotové ceny"
              />
            }
            switchVariableId="NOTIF_SPOT_CHARGING_BATTERY_ENABLE"
            fullWidth
            visibility={{
              variableIds: [
                'SP_BATTERY_CONTROL_CUSTOMER',
                'SP_ON',
                'SP_INSTALL',
              ],
            }}
          />
          <SwitchBox
            title={
              <FormattedMessage
                id="settings.notification.spot_discharging_battery"
                defaultMessage="Start a konec vybíjení baterie do sítě dle spotové ceny"
              />
            }
            subtitle={
              <FormattedMessage
                id="settings.notification.spot_discharging_battery.subtitle"
                defaultMessage="Notifikace se vygeneruje při začátku a konci vybíjení baterie do sítě dle spotové ceny"
              />
            }
            switchVariableId="NOTIF_SPOT_DISCHARGING_BATTERY_ENABLE"
            fullWidth
            visibility={{
              variableIds: ['SP_DISCHARGE_TO_GRID', 'SP_ON', 'SP_INSTALL'],
            }}
          />
        </ParentPaper>
        <ParentPaper>
          <SwitchBox
            title={
              <FormattedMessage
                id="settings.notification.heat_water_max_temperature"
                defaultMessage="Dosažena maximální teplota vody v bojleru"
              />
            }
            subtitle={
              <FormattedMessage
                id="settings.notification.heat_water_max_temperature.subtitle"
                defaultMessage="Notifikace se vygeneruje při dosažení požadované maximální teploty vody v bojleru z FV energie"
              />
            }
            switchVariableId="NOTIF_HEAT_WATER_MAX_TEMP_ENABLE"
            fullWidth
            visibility={{ variableIds: ['HW_ON', 'HW_TEMP_ENABLED'] }}
          />
        </ParentPaper>
        <ParentPaper>
          <SwitchBox
            title={
              <FormattedMessage
                id="settings.notification.wallbox_charging_start_stop"
                defaultMessage="Start a konec nabíjení elektromobilu"
              />
            }
            subtitle={
              <FormattedMessage
                id="settings.notification.wallbox_charging_start_stop.subtitle"
                defaultMessage="Notifikace se vygeneruje při začátku a konci nabíjení elektromobilu"
              />
            }
            switchVariableId="NOTIF_WALLBOX_CHARGING_ENABLE"
            fullWidth
            visibility={{ variableIds: ['WB_INSTALL'] }}
          />
        </ParentPaper>
        <ParentPaper>
          <SwitchBox
            title={
              <FormattedMessage
                id="settings.notification.home_consumption_limit_exceeded"
                defaultMessage="Překročení limitu spotřeby domácnosti"
              />
            }
            subtitle={
              <FormattedMessage
                id="settings.notification.home_consumption_limit_exceeded.subtitle"
                defaultMessage="Notifikace se vygeneruje při překročení nastaveného limitu spotřeby domácnosti"
              />
            }
            switchVariableId="NOTIF_LIMIT_HOME_ENABLE"
            fullWidth
          />
          <SliderBox
            title={
              <FormattedMessage
                id="settings.notification.home_consumption_limit_value"
                defaultMessage="Denní limit spotřeby domácnosti pro notifikace"
              />
            }
            subtitle={
              <FormattedMessage
                id="settings.notification.home_consumption_limit_value.subtitle"
                defaultMessage="Nastavte limit spotřeby domácnosti, při jehož překročení se vygeneruje notifikace."
              />
            }
            variableId="NOTIF_LIMIT_HOME_VALUE"
            opts={{
              maximumFractionDigits: 0,
              style: 'unit',
              unit: 'kilowatt-hour',
            }}
            step={1}
            min={1}
            max={150}
            visibility={{ variableId: 'NOTIF_LIMIT_HOME_ENABLE' }}
          />
        </ParentPaper>
        <ParentPaper>
          <SwitchBox
            title={
              <FormattedMessage
                id="settings.notification.heat_water_limit_exceeded"
                defaultMessage="Překročení limitu ohřevu vody"
              />
            }
            subtitle={
              <FormattedMessage
                id="settings.notification.heat_water_limit_exceeded.subtitle"
                defaultMessage="Notifikace se vygeneruje při překročení nastaveného limitu ohřevu vody"
              />
            }
            switchVariableId="NOTIF_LIMIT_HEAT_WATER_ENABLE"
            fullWidth
            visibility={{ variableIds: ['HW_INSTALL'] }}
          />
          <SliderBox
            title={
              <FormattedMessage
                id="settings.notification.heat_water_limit_value"
                defaultMessage="Denní limit ohřevu vody pro notifikace"
              />
            }
            subtitle={
              <FormattedMessage
                id="settings.notification.heat_water_limit_value.subtitle"
                defaultMessage="Nastavte limit ohřevu vody, při jehož překročení se vygeneruje notifikace."
              />
            }
            variableId="NOTIF_LIMIT_HEAT_WATER_VALUE"
            opts={{
              maximumFractionDigits: 0,
              style: 'unit',
              unit: 'kilowatt-hour',
            }}
            step={1}
            min={1}
            max={30}
            visibility={{
              variableIds: ['NOTIF_LIMIT_HEAT_WATER_ENABLE', 'HW_INSTALL'],
            }}
          />
        </ParentPaper>
        <ParentPaper>
          <SwitchBox
            title={
              <FormattedMessage
                id="settings.notification.heat_pump_limit_exceeded"
                defaultMessage="Překročení limitu spotřeby tepelného čerpadla"
              />
            }
            subtitle={
              <FormattedMessage
                id="settings.notification.heat_pump_limit_exceeded.subtitle"
                defaultMessage="Notifikace se vygeneruje při překročení nastaveného limitu spotřeby tepelného čerpadla"
              />
            }
            switchVariableId="NOTIF_LIMIT_HEAT_PUMP_ENABLE"
            fullWidth
            visibility={{ variableIds: ['HP_ENABLED'] }}
          />
          <SliderBox
            title={
              <FormattedMessage
                id="settings.notification.heat_pump_limit_value"
                defaultMessage="Denní limit spotřeby tepelného čerpadla pro notifikace"
              />
            }
            subtitle={
              <FormattedMessage
                id="settings.notification.heat_pump_limit_value.subtitle"
                defaultMessage="Nastavte limit spotřeby tepelného čerpadla, při jehož překročení se vygeneruje notifikace."
              />
            }
            variableId="NOTIF_LIMIT_HEAT_PUMP_VALUE"
            opts={{
              maximumFractionDigits: 0,
              style: 'unit',
              unit: 'kilowatt-hour',
            }}
            step={1}
            min={1}
            max={50}
            visibility={{
              variableIds: ['NOTIF_LIMIT_HEAT_PUMP_ENABLE', 'HP_ENABLED'],
            }}
          />
        </ParentPaper>
        <ParentPaper>
          <SwitchBox
            title={
              <FormattedMessage
                id="settings.notification.wallbox_limit_exceeded"
                defaultMessage="Překročení limitu nabíjení elektromobilu"
              />
            }
            subtitle={
              <FormattedMessage
                id="settings.notification.wallbox_limit_exceeded.subtitle"
                defaultMessage="Notifikace se vygeneruje při překročení nastaveného limitu nabíjení elektromobilu"
              />
            }
            switchVariableId="NOTIF_LIMIT_WALLBOX_ENABLE"
            fullWidth
            visibility={{ variableId: 'WB_INSTALL' }}
          />
          <SliderBox
            title={
              <FormattedMessage
                id="settings.notification.wallbox_limit_value"
                defaultMessage="Denní limit nabíjení elektromobilu pro notifikace"
              />
            }
            subtitle={
              <FormattedMessage
                id="settings.notification.wallbox_limit_value.subtitle"
                defaultMessage="Nastavte limit nabíjení elektromobilu, při jehož překročení se vygeneruje notifikace."
              />
            }
            variableId="NOTIF_LIMIT_WALLBOX_VALUE"
            opts={{
              maximumFractionDigits: 0,
              style: 'unit',
              unit: 'kilowatt-hour',
            }}
            step={1}
            min={1}
            max={80}
            visibility={{
              variableIds: ['NOTIF_LIMIT_WALLBOX_ENABLE', 'WB_INSTALL'],
            }}
          />
        </ParentPaper>
      </Group>
    </>
  );
};

type WindowState = {
  hasToken: boolean;
  notificationsSupported: boolean;
  iosPwaSupported: boolean;
  getSubscription: (deviceId: string) => Promise<boolean>;
  setSubscription: (value: boolean, deviceId: string) => Promise<void>;
};

type State =
  | 'unknown'
  | 'error-loading'
  | 'loading'
  | 'not-supported'
  | 'ios-pwa-supported'
  | 'not-enabled'
  | 'enabled';

const WebNotifications = () => {
  const deviceId = useSelector(({ variables: { DEVICE_ID } }) => DEVICE_ID);

  const [state, setState] = useState<State>('unknown');

  const updateState = () => {
    const windowState = getStateFromWindow();

    if (!windowState) {
      setState('error-loading');
      return;
    }

    if (!windowState.notificationsSupported && windowState.iosPwaSupported) {
      setState('ios-pwa-supported');
      return;
    }

    if (!windowState.notificationsSupported) {
      setState('not-supported');
      return;
    }

    if (!windowState.hasToken) {
      setState('not-enabled');
      return;
    }

    setState('loading');

    windowState
      .getSubscription(deviceId)
      .then((result) => {
        if (result) {
          setState('enabled');
        } else {
          setState('not-enabled');
        }
      })
      .catch(() => {
        setState('error-loading');
      });
  };

  useEffect(() => {
    const handleStateChanged = () => {
      updateState();
    };

    window.addEventListener(
      'app-web-notifications-state-changed',
      handleStateChanged
    );

    setTimeout(() => {
      updateState();
    }, 500);

    return () => {
      window.removeEventListener(
        'app-web-notifications-state-changed',
        handleStateChanged
      );
    };
  }, [deviceId]);

  // debug
  // useEffect(() => {
  //   console.log('WebNotifications state:', state);
  // }, [state]);

  const handleSwitchChange = async () => {
    if (['not-enabled', 'enabled'].includes(state)) {
      await getStateFromWindow()?.setSubscription(
        state !== 'enabled',
        deviceId
      );
      updateState();
    }

    if (state === 'ios-pwa-supported') {
      window.open(
        'https://infigy.cz/app-redirect/wiki-ios-pwa',
        '_blank',
        'noopener,noreferrer'
      );
    }
  };

  return (
    <ControlBox
      title={
        <FormattedMessage
          id="settings.notification.webapp.title"
          defaultMessage="Webová aplikace"
        />
      }
      subtitle={
        <FormattedMessage
          id="settings.notification.webapp.subtitle"
          defaultMessage="Notifikace z Infigy můžete dostávat přes webovou aplikaci."
        />
      }
      control={
        <Switch
          sx={{ ml: 'auto' }}
          disabled={['loading', 'error-loading', 'not-supported'].includes(
            state
          )}
          checked={state === 'enabled'}
          onChange={() => handleSwitchChange()}
        />
      }
      fullWidth
    />
  );
};

// Example of a possible window.webNotifications state
/*
  window.webNotifications = {
    hasToken: false,
    notificationsSupported: false,
    iosPwaSupported: false,
    getSubscription: async () => true,
    setSubscription: async () => {},
  };
  window.dispatchEvent(new CustomEvent('app-web-notifications-state-changed'));
 */

// Example of event dispatch
// window.dispatchEvent(new CustomEvent('app-web-notifications-state-changed'));

function getStateFromWindow(): WindowState | undefined {
  // eslint-disable-next-line
  // @ts-ignore
  return window.webNotifications;
}
